import { render, staticRenderFns } from "./LsvaDashboardView.vue?vue&type=template&id=faefe16a&scoped=true&"
import script from "./LsvaDashboardView.vue?vue&type=script&lang=js&"
export * from "./LsvaDashboardView.vue?vue&type=script&lang=js&"
import style0 from "./LsvaDashboardView.vue?vue&type=style&index=0&id=faefe16a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faefe16a",
  null
  
)

/* custom blocks */
import block0 from "./LsvaDashboardView.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports